import { Controller, UseFormReturn } from 'react-hook-form';
import { ConfigurationFormData } from '../../types';
import { buildTextInputValidationRules } from './utils';
import { BorderedInput } from '@navi/web-ui/lib/primitives';

interface TextInputFieldProps {
  control: UseFormReturn<ConfigurationFormData>['control'];
  errors: UseFormReturn<ConfigurationFormData>['formState']['errors'];
  fieldName: keyof ConfigurationFormData;
  label: string;
  mandatory: boolean;
  maxValue?: number;
  placeholder?: string;
}

const TextInputField = (props: TextInputFieldProps) => {
  const { control, errors, fieldName, label, mandatory, maxValue, placeholder } = props;

  return (
    <Controller
      control={control}
      name={fieldName}
      rules={buildTextInputValidationRules(mandatory, label, maxValue)}
      render={({ field: { onChange, value, ref } }) => (
        <BorderedInput
          ref={ref}
          placeholder={placeholder || label}
          value={value || ''}
          onChange={onChange}
          error={errors[fieldName]?.message}
          fullWidth={true}
        />
      )}
    />
  );
};

export default TextInputField;
